import { APP_INITIALIZER, Injector } from '@angular/core';
import { combineLatest } from 'rxjs';
import { RoutesService } from '@abp/ng.core';
import { TASKS_MANAGEMENT_ROUTE_VISIBILITY } from './features.token';
import { ProviderConsts } from 'src/app/shared/Constants/providers.constants';

export const TASKS_MANAGEMENT_VISIBLE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: tasksManagementVisibility,
        deps: [Injector],
        multi: true,
    },
];

export function tasksManagementVisibility(injector: Injector) {
    return () => {
        const isTaskManagementFeatureEnable$ = injector.get(TASKS_MANAGEMENT_ROUTE_VISIBILITY);
        const routes = injector.get(RoutesService);
        combineLatest([isTaskManagementFeatureEnable$]).subscribe(
        ([isTaskManagementFeatureEnable]) => {
            routes.patch(ProviderConsts.TASK_ROUTE_PATCH_NAME, {
            invisible: !isTaskManagementFeatureEnable,
            });
        },
        );
    };
}
